import styled from 'styled-components';

export const Container = styled.div<{ size?: number }>`
  svg {
    width: ${props => props.size ?? 100}px;
  }
`;
